import React from 'react';
import './Cover.css';
import afroditaLogo from '../../assets/images/afrodita_logo.webp';

interface CoverProps {
  /** Использовать тег h1 (для SEO - только один на странице) */
  useH1?: boolean;
}

const Cover: React.FC<CoverProps> = React.memo(({ useH1 = false }) => {
  const logoElement = (
    <img src={afroditaLogo} alt="АФРОДИТА" className="cover-image" />
  );

  return (
    <div className="cover-glass-block">
      <div className="cover-content">
        {useH1 ? (
          <h1 className="cover-main">{logoElement}</h1>
        ) : (
          <div className="cover-main">{logoElement}</div>
        )}
      </div>
    </div>
  );
});

Cover.displayName = 'Cover';

export default Cover;
